export default __webpack_public_path__ + "static/media/3.fd5531c2.jpeg";